import React, { FC, PropsWithChildren, cloneElement, ReactElement, Suspense } from 'react'
import { createPortal } from 'react-dom'
import reactComponentMapping from './Component-Mapping'
import ReactQuery from './providers/ReactQuery'
import SearchContextProvider from './context/search.context'
import ErrorBoundaryPage from './ErrorBoundaryPage'

interface PortalComponents {
  component: ReactElement
  element: Element
}

const App: FC<PropsWithChildren> = () => {
  const searchHeaderElement = document.querySelector('#searchIconElastic')
  searchHeaderElement?.setAttribute('data-dtc-component', 'SearchHeader')

  const searchResultsElement = document.querySelector('#searchResult')
  searchResultsElement?.setAttribute('data-dtc-component', 'SearchResults')

  const nodes = [searchHeaderElement, searchResultsElement]
  const portalComponents: PortalComponents[] = []

  nodes.forEach((element) => {
    const componentName = element ? element.getAttribute('data-dtc-component') : 'DummyComponent'
    // eslint-disable-next-line
    const attrs: Record<string, any> = {}
    if (element) {
      for (let i = 0; i < element.attributes.length; i++) {
        const { name, value } = element.attributes[i]
        attrs[name] = value
      }
    }

    if (componentName != null && reactComponentMapping[componentName]) {
      const component: React.ReactElement = cloneElement(
        reactComponentMapping[componentName] as JSX.Element,
        {
          ...attrs
        }
      ) as React.ReactElement

      if (element != null && component != null) {
        portalComponents.push({
          component: <>{component}</>, // You might need to adjust the wrapper div here
          element
        })
      }
    }
  })

  return (
    <Suspense>
      <ErrorBoundaryPage>
        <ReactQuery>
          <SearchContextProvider>
            {portalComponents.map(({ component, element }) => {
              return createPortal(component, element)
            })}
          </SearchContextProvider>
        </ReactQuery>
      </ErrorBoundaryPage>
    </Suspense>
  )
}

export default App
